import React from 'react';

interface Task {
    url: string;
    project: string;
    name: string;
    isBillable: boolean;
    billingRate: string;
    billingPeriod: string;
    status: string;
    createdAt: string;
    updatedAt: string;
    jiraKey: string;
}

type Props = {
    tasks: Task[];
    missingKeys: string[];
};

const TasksList: React.FC<Props> = ({ tasks, missingKeys }) => (
    <ul>
        {tasks.map((task) => (
            <li key={task.url} style={missingKeys.includes(task.jiraKey) ? { color: 'red' } : {}}>
                {task.name} - {task.status}
            </li>
        ))}
    </ul>
);

export default TasksList;